import {
  modifyMember as modifyMemberRes,
  bulkModifyMember as bulkModifyMemberRes,
  bulkCreateMember as bulkCreateMemberRes,
  delMember as delMemberRes,
} from "../api/member";
import { updateUserInfo } from "./user";
import store from "../store/index";
import { CURRENT_USER_INFO_SIMPLE } from "../store/mutation-types";

/**
 * 批量修改绑定的publisher
 * @param memberId 对应member
 * @param email 对应邮箱
 * @param ids 选中publisher
 * @param emailNotChange 邮箱是否未修改
 * @returns {Promise<void>}
 */
export async function modifyPublisher({
  memberId,
  email,
  ids,
  emailNotChange,
}) {
  let id = memberId;
  if (!emailNotChange) {
    const { data } = await modifyMemberRes({
      memberId: memberId,
      new_member_email: email,
    });
    id = data.member_id;
  }
  const { data } = await bulkModifyMemberRes({
    memberId: id,
    publisher_ids: ids.toString(),
  });
  await updateUserInfo({});
  return data;
}

/**
 * 创建member
 * @param email 邮箱
 * @param ids 选中的publisher
 * @returns {Promise<*>}
 */
export async function createMember({ email, ids }) {
  const { data } = await bulkCreateMemberRes({
    member_email: email,
    publisher_ids: ids.toString(),
  });
  await updateUserInfo({});
  return data;
}

/**
 * 删除member中publisher
 * @param id member id
 * @param publisherId 删除的publisher
 * @returns {Promise<void>}
 */
export async function removeMemberPublisher({ id, publisherId }) {
  // 获取用户选中member
  const user = store.getters[CURRENT_USER_INFO_SIMPLE];
  const member = user.teamMemberList.find((t) => t.id === id);
  const ids = member.publishers
    .map((p) => p.publisherId)
    .filter((p) => p !== publisherId);
  const { data } = await modifyPublisher({
    memberId: member.id,
    ids: ids.toString(),
    email: member.memberEmail,
  });
  return data;
}

/**
 * 删除对应member
 */
export async function removeMember({ memberId }) {
  // 调取删除接口
  const { data } = await delMemberRes({ id: memberId });
  await updateUserInfo({});
  return data;
}
